import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { DefinitionModel } from 'Shared/components';
import getSelectedModel from '../../utils/getSelectedModel';
import styles from '../../ModelDefinitions.css';
const DefaultModelDefinitions = ({ modelName }) => {
    const { model, definition } = useMemo(() => getSelectedModel(modelName), [modelName]);
    return (_jsx("div", Object.assign({ className: styles.definitionWrapper }, { children: _jsx(DefinitionModel, { description: definition.description, list: definition.list, modelName: model }, void 0) }), void 0));
};
export default memo(DefaultModelDefinitions);
